export const release = "05-NOV-26 16:40:01";
export const lemmonEnv: any = (globalThis as any).lemmonEnv;
